import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

const Row = (props) => {
  const { slim, label, value } = props

  return (
    <tr>
      {!slim && (
        <td width="1%" className="text-nowrap">
          <div className="text-small text-muted text-right">{label}</div>
        </td>
      )}
      <td>{value}</td>
    </tr>
  )
}

export default Row
